(function () {
    "use strict";

    angular
        .module("app")
        .service("addressService", service);

    function service($http, $q) {
        const self = this;
        self.shippingAddresses = [];
        self.billingAddresses = [];
        self.allDeas = [];

        self.refresh = companyId => {
            return $q
                .all([
                    self.getShipping(companyId),
                    self.getBilling(companyId)
                ])
                .then(([shipping, billing]) => {
                    self.shippingAddresses = shipping;
                    self.billingAddresses = billing;
                });
        };

        self.getBilling = companyId => {
            return getAddresses(companyId, 2);
        };

        self.getShipping = companyId => {
            return $q
                .all([
                    getAddresses(companyId, 3),
                    getDeaNumbers(companyId)
                ])
                .then(([addresses, deas]) => {
                    self.allDeas = deas;
                    addresses.forEach(a => a.deas = deas.filter(d => d.contact_id === a.contact_id).sort(sortDeas));
                    return addresses;
                });
        };

        function getAddresses(companyId, contactType) {
            return $http
                .get(`/api/addresses/for-customer/${companyId}/of-type/${contactType}`)
                .then(res => res.data.sort(sortAddresses));
        }

        function getDeaNumbers(customerId) {
            return $http.get(`/api/customers/${customerId}/dea-numbers`).then(res => res.data);
        }

        self.getShippingByShipDate = (customer_id, ship_from_date, ship_to_date) => {
            return $http
                .post(`/api/addresses/load-shipping-addresses`, { customer_id, ship_from_date, ship_to_date })
                .then(res => res.data.sort(sortAddresses));
        }

        self.getShippingByOrderDate = (customer_id, order_from_date, order_to_date) => {
            return $http
                .post(`/api/addresses/shipping-addresses-by-order-date`, { customer_id, order_from_date, order_to_date })
                .then(res => res.data.sort(sortAddresses));
        }

        function sortAddresses(a, b) {
            if (`${a.first_name} ${a.last_name}` < `${b.first_name} ${b.last_name}`)
                return -1;
            if (`${a.first_name} ${a.last_name}` > `${b.first_name} ${b.last_name}`)
                return 1;
            return 0;
        }

        function sortDeas(a, b) {
            if (a.identification_code < b.identification_code)
                return -1;
            if (a.identification_code > b.identification_code)
                return 1;
            return 0;
        }

    }
    service.$inject = ["$http", "$q"];

})()